module.exports = __webpack_public_path__ + "img/grn_ch_grimgor_0.cd69a575.png";